export default __webpack_public_path__ + "static/media/paint.7198215e.jpg";